var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "messages_med",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.258,
    height: 19.405,
    viewBox: "0 0 24.258 19.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Messages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "messages-solid-2",
    d: "M2.426,0A2.428,2.428,0,0,0,0,2.426V9.7a2.428,2.428,0,0,0,2.426,2.426H3.639v1.819a.6.6,0,0,0,.334.542.614.614,0,0,0,.637-.057l3.074-2.3h5.659A2.428,2.428,0,0,0,15.768,9.7V2.426A2.428,2.428,0,0,0,13.342,0ZM13.342,13.342H9.7v1.213a2.428,2.428,0,0,0,2.426,2.426h4.446l3.074,2.3a.612.612,0,0,0,.637.057.6.6,0,0,0,.334-.542V16.98h1.213a2.428,2.428,0,0,0,2.426-2.426V7.277a2.428,2.428,0,0,0-2.426-2.426H16.98V9.7A3.64,3.64,0,0,1,13.342,13.342Z",
    fill: "inharit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.a293321f45dc99e45a1099b22e1a3fdb.svg";
export { ForwardRef as ReactComponent };